import { createGenericStore } from '@/stores/utils/genericStore.js'

const UploadableStoreOptions = {
  state: () => ({
    uploadableId: null,
    uploadableType: null,
  }),

  getters: {
    hasActiveUploadableContext(state) {
      return state.uploadableId !== null && typeof state.uploadableType === 'string' && state.uploadableType.length > 0
    },
  },

  actions: {
    setUploadableContext(uploadableId, uploadableType) {
      this.uploadableId = Number(uploadableId)
      this.uploadableType = uploadableType
    },

    async fetchItemsForUploadable(uploadableId, uploadableType, params = {}) {
      this.setUploadableContext(uploadableId, uploadableType)

      return this.fetchItems({
        clear: true,
        uploadable_id: this.uploadableId,
        uploadable_type: this.uploadableType,
        order_by: 'id',
        order_direction: 'desc',
        ...params,
      })
    },
  },
}

export const useUploadableStore = createGenericStore(
  'Uploadable',
  '/uploads',
  UploadableStoreOptions
)
